import { useThemeMode } from "@/theme/ThemeContext";

const lightColors = {
  primary: "#6366f1",
  secondary: "#a78bfa",
  success: "#16a34a",
  error: "#dc2626",
  warning: "#f59e0b",
  info: "#3b82f6",
  teal: "#0d9488",
};

const darkColors = {
  primary: "#818cf8",
  secondary: "#c4b5fd",
  success: "#4ade80",
  error: "#f87171",
  warning: "#fbbf24",
  info: "#60a5fa",
  teal: "#2dd4bf",
};

export function useChartColors() {
  const { mode } = useThemeMode();
  return mode === "dark" ? darkColors : lightColors;
}
